export { InlineNotificationComponent } from './inline-notification.component';
export { InlineNotificationModule } from './inline-notification.module';
